<template>
  <RevInfoBlock
    :content="warningLabel"
    :icon="IconWarning"
    :title="i18n(translations.warningTitle)"
    variant="warning"
  />
  <ul class="body-2 mt-12 list-disc space-y-12 pl-20">
    <li v-if="orderlineQuantity > 1">
      {{
        i18n(translations.productQuantityRemark, {
          productQuantity: orderlineQuantity,
        })
      }}
    </li>
    <li v-if="hasActiveInsurancePolicy">
      {{ i18n(translations.insurancePolicyRemark) }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from './RefundWarning.translations'

const i18n = useI18n()

const props = defineProps<{
  isPartialRefundAllowed: boolean
  maxRefundPrice: Price
  hasActiveInsurancePolicy: boolean
  orderlineQuantity: number
}>()

const warningLabel = computed(() => {
  if (!props.isPartialRefundAllowed) {
    return i18n(translations.fullRefundLabel, {
      maxRefundablePrice: i18n.price(props.maxRefundPrice),
    })
  }

  return i18n(translations.defaultLabel, {
    maxRefundablePrice: i18n.price(props.maxRefundPrice),
  })
})
</script>
